import api from './api';

export interface GuestCategory {
  id: string;
  wedding_id: string;
  name: string;
  level: number;
  parent_id: string | null;
  color: string | null;
  created_at: string;
}

export interface GuestCategoryFormData {
  name: string;
  level: number;
  parent_id?: string | null;
  color?: string | null;
}

export const getGuestCategories = (params?: Record<string, string | number>) =>
  api.get<GuestCategory[]>('/guest-categories', { params });
export const createGuestCategory = (data: GuestCategoryFormData) =>
  api.post<GuestCategory>('/guest-categories', data);
export const updateGuestCategory = (id: string, data: { name?: string; color?: string }) =>
  api.put<GuestCategory>(`/guest-categories/${id}`, data);
export const deleteGuestCategory = (id: string) =>
  api.delete(`/guest-categories/${id}`);
